<template>
	<div class="row person-info" align-y="top" align-x="between">
		<el-form label-position="left" label-width="160px">
			<el-form-item label="姓名">
				<span>{{userInfo.name}}</span>
			</el-form-item>
			<el-form-item label="姓名拼音">
				<span v-if="userInfo.wade_giles">{{userInfo.wade_giles}}</span>
				<span v-else class="color-danger">尚未填寫</span>
			</el-form-item>
			<el-form-item label="性別">
				<span>{{userInfo.gender}}</span>
			</el-form-item>
			<el-form-item label="出生年月日">
				<span>{{userInfo.born_date | moment("YYYY/MM/DD")}}</span>
			</el-form-item>
			<el-form-item label="Email">
				<span>{{userInfo.email}}</span>
			</el-form-item>
			<el-form-item label="手機">
				<span>{{userInfo.phone}}</span>
			</el-form-item>
			<el-form-item label="學校電話（分機）">
				<span>{{userInfo.tel}}</span>
			</el-form-item>
			<el-form-item label="密碼">
				<div class="button-tp change-pwd color-white bg-blue1" @click="clickChangePwd">更改密碼</div>
			</el-form-item>
			<el-form-item label="介紹人">
				<span v-if="userInfo.introducer">{{userInfo.introducer}}</span>
				<span v-else class="color-danger">尚未填寫</span>
			</el-form-item>
		</el-form>
		<el-button @click="edit()" type="text">點選修改
			<i class="el-icon-arrow-right"></i>
		</el-button>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	data() {
		return {};
	},
	computed: {
		...mapState("user", ["userInfo"])
	},
	methods: {
		edit() {
			this.$emit("edit");
		},
		clickChangePwd() {
			this.$router.push({ name: "ChangePassword" });
		}
	}
};
</script>

<style lang="scss" scoped>
.el-form-item {
	margin-bottom: auto;

	.change-pwd {
		width: 114px;
		height: 24px;
		margin-top: 6px;
	}
}
</style>
